import { ColumnKey } from '../types';

export const SHARED_DONOR_KEYS: ColumnKey[] = [
  'registeredAt',
  'ownerFullName',
  'donorName',
  'contactInfo',
  'location',
  'region',
  'lastDonationDate',
  'status',
  'sglDbl',
  'totalDonations',
];

export const PRBC_DONOR_KEYS: ColumnKey[] = [
  'registeredAt',
  'ownerFullName',
  'donorName',
  'breed',
  'location',
  'region',
  'lastDonationDate',
  'status',
  'sglDbl',
  'periodUnits',
  'totalDonations',
  'bloodTypeDisplay',
];

export const PENDING_DONOR_KEYS: ColumnKey[] = [
  'registeredAt',
  'daysPending',
  'ownerFullName',
  'donorName',
  'breed',
  'location',
  'region',
  'status',
  'sglDbl',
  'bloodTypeDisplay',
];

export const RETIRED_DONOR_KEYS: ColumnKey[] = [
  'registeredAt',
  'ownerFullName',
  'donorName',
  'contactInfo',
  'location',
  'region',
  'lastDonationDate',
  'retiredDate',
  'status',
  'sglDbl',
  'totalDonations',
];

export const LAPSED_DONOR_KEYS: ColumnKey[] = [
  ...SHARED_DONOR_KEYS,
  'contacted',
];
